/**
 * Factory function to create filtered data initialization handler
 * @param {Object} params - Parameters object
 * @param {Array} params.groupedTimerData - Grouped timer data array
 * @param {Function} params.setFilteredData - Setter for filtered data
 * @param {Object} params.hasInitializedFilteredDataRef - Ref to track initialization
 * @returns {Function} Initialization function
 */
export const createFilteredDataInitializationHandler = ({
  groupedTimerData,
  setFilteredData,
  hasInitializedFilteredDataRef,
}) => {
  return () => {
    try {
      if (!Array.isArray(groupedTimerData)) {
        if (hasInitializedFilteredDataRef.current) {
          // Only reset if we've already initialized
          setFilteredData([]);
          hasInitializedFilteredDataRef.current = false;
        }
        return;
      }

      // Only initialize once when data first becomes available
      // After that, let the onChange handler manage filteredData
      if (!hasInitializedFilteredDataRef.current && groupedTimerData.length > 0) {
        hasInitializedFilteredDataRef.current = true;
        setFilteredData(groupedTimerData);
      } else if (hasInitializedFilteredDataRef.current && groupedTimerData.length === 0) {
        // Reset if data becomes empty after initialization
        setFilteredData([]);
        hasInitializedFilteredDataRef.current = false;
      }
    } catch (error) {
      console.error("Error in setting filtered timer data:", error);
      setFilteredData([]);
      hasInitializedFilteredDataRef.current = false;
    }
  };
};
